

















































import { Component, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import { Blip, Item } from '@/types/domain'

@Component({
  computed: {
    ...mapGetters('items', [
      'team',
      'devs',
      'hasItems'
    ]),
    ...mapGetters('settings', [
      'selectedBlipsTitle'
    ]),
    items () {
      return this.hasItems ? [this.team].concat(this.devs) : []
    },
    categories () {
      return this.hasItems ? this.team.payload.meta.categories : []
    },
    blipsByCategory () {
      return (itemIx, categoryIx) => {
        return this.items[itemIx].payload.blips
          .filter(e => e.category === categoryIx)
      }
    }
  }
})

export default class SelectBlips extends Vue {
  activeItemIx: number = 0
  chip: boolean = true
  
  // computed
  team: Item
  devs: Item[]
  hasItems: boolean
  selectedBlipsTitle: string[]
  items: Item[]
  categories: string[]
  blipsByCategory: Blip[]

  checkComplete () {
    if (this.selectedBlipsTitle.length > 0) {
      this.$emit('isComplete', true)
    } else {
      this.$emit('isComplete', false)
    }
  }
  itemDone (value) {
    this.activeItemIx = ++value
    this.checkComplete()
  }

  isSelected (blip) {
    return !!this.selectedBlipsTitle.find(e => e.toLowerCase() === blip.title.toLowerCase())
  }

  toggleBlip (blip) {
    if (this.isSelected(blip)) {
      this.$store.dispatch('settings/deselectBlip', blip)
    } else {
      this.$store.dispatch('settings/selectBlip', blip)
    }
    this.checkComplete()
  }

  getBlipCount (blip) {
    return this.items
      .map(i => i.payload.blips.filter(e => e.title.toLowerCase() === blip.title.toLowerCase()))
      .flat()
      .length
  }

  initSelectedBlips () {
    if (this.selectedBlipsTitle.length < 1 && this.hasItems) {
      console.log(this.$store)
      this.team.payload.blips.forEach(b => this.$store.dispatch('settings/selectBlip', b))
    }
  }

  mounted () {
    this.initSelectedBlips()
  }
}

